export default "__VITE_ASSET__Dwfu8RVr__"